module.exports = __webpack_public_path__ + "static/img/9.647cb65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/9.jpg
// module id = lTBX
// module chunks = 1